import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { SearchSchema } from "./-zod-schemas";

export const Route = createFileRoute("/_staff/software/_layout/registry/")({
  validateSearch: zodValidator(SearchSchema),
});
